import createClient, { type Client } from 'openapi-fetch';

import { sessionMiddleware } from './session';
import type { SimulatorPaths } from './types';

export type SimulatorClient = Client<SimulatorPaths>;

/**
 * The path every API call goes through: nginx (the image) and Vite (development) proxy it to the simulator's control
 * API, so the app never needs CORS.
 */
export const API_BASE_PATH = '/api';

/** Resolves a same-origin base path such as `/api` into an absolute URL without a trailing slash. */
export function resolveBaseUrl(basePath: string, origin: string = globalThis.location.origin): string {
  return new URL(basePath, origin).toString().replace(/\/$/, '');
}

/** The typed client of the control API (generated from openapi/simulator-api.yaml). */
export function createSimulatorClient(basePath: string = API_BASE_PATH): SimulatorClient {
  // Look fetch up per call, so test and mock tooling that patches globalThis.fetch later still applies.
  const client = createClient<SimulatorPaths>({
    baseUrl: resolveBaseUrl(basePath),
    fetch: (request: Request) => globalThis.fetch(request),
  });
  client.use(sessionMiddleware);
  return client;
}
